import React, { useState, useRef, useEffect } from 'react';
import { Send, Settings, Globe, Plus, Trash2, Save, History, X, MessageSquare, Edit2, ArrowRight, Zap } from 'lucide-react';

const ChatBot = () => {
  const [language, setLanguage] = useState('en');
  const [showAdmin, setShowAdmin] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [apiKey, setApiKey] = useState('');
  const [showApiForm, setShowApiForm] = useState(false);
  const [systemPrompt, setSystemPrompt] = useState(
    `You are an expert real estate sales consultant specializing in helping buyers find genuine property offers in Egypt. Your role is to provide comprehensive guidance and connect potential buyers with real property listings.

PREMIUM FEATURED PROPERTIES:

CAIRO - MODERN APARTMENTS:
1. New Cairo - Luxury Apartment
   - Size: 250 sq meters, 3 Bedrooms, 3 Bathrooms
   - Location: New Cairo, near AUC and Tech Valley
   - Features: Full furnished, AC, balcony overlooking gardens, security 24/7
   - Price: 3,500,000 - 4,200,000 EGP
   - Best For: Families, professionals, investment
   - ROI: 8-12% annual rental yield

2. Maadi - Contemporary Apartment
   - Size: 180 sq meters, 2 Bedrooms, 2 Bathrooms
   - Location: Maadi near Metro, shopping centers, schools
   - Features: Modern kitchen, high-speed internet, gym access, garden access
   - Price: 2,800,000 - 3,400,000 EGP
   - Best For: Young professionals, couples
   - Rental Demand: Very High

3. Heliopolis - Family Villa Apartment
   - Size: 220 sq meters, 3 Bedrooms, 2.5 Bathrooms
   - Location: Heliopolis, near schools and universities
   - Features: Spacious rooms, excellent views, quiet neighborhood
   - Price: 2,400,000 - 2,900,000 EGP
   - Best For: Families with children
   - Community: Well-established, safe area

GIZA - RESIDENTIAL OPTIONS:
4. Haram - Modern Flat
   - Size: 150 sq meters, 2 Bedrooms, 1 Bathroom
   - Location: Near metro, close to shopping districts
   - Features: Newly renovated, high ceilings, good sunlight
   - Price: 1,800,000 - 2,200,000 EGP
   - Best For: First-time buyers, investors
   - Appreciation: Growing area

5. Sheikh Zayed City - Community Living
   - Size: 170 sq meters, 2-3 Bedrooms, 2 Bathrooms
   - Location: Gated community, Sheikh Zayed
   - Features: Pool access, gym, sports courts, green spaces
   - Price: 2,500,000 - 3,100,000 EGP
   - Best For: Families wanting community amenities
   - Lifestyle: Modern, family-friendly

ALEXANDRIA - BEACHFRONT & COASTAL:
6. Al Montaza - Sea View Apartment
   - Size: 200 sq meters, 3 Bedrooms, 2 Bathrooms
   - Location: Coastal area, near beach and marina
   - Features: Sea views, balconies, modern finishes, security
   - Price: 2,200,000 - 2,700,000 EGP
   - Best For: Vacation homes, sea lovers
   - Potential: Tourism investment

7. Mandara - Quiet Residential Area
   - Size: 160 sq meters, 2 Bedrooms, 2 Bathrooms
   - Location: Calm coastal neighborhood, near restaurants
   - Features: Mediterranean style, peaceful ambiance
   - Price: 1,900,000 - 2,400,000 EGP
   - Best For: Retirees, remote workers

PRIME LOCATIONS DATA:

CAIRO DISTRICTS:
- New Cairo: Premium location, modern infrastructure, tech hub, avg. 15,000-20,000 EGP/sqm
- Maadi: Upscale community, good schools, metro accessible, avg. 12,000-18,000 EGP/sqm
- Heliopolis: Historic, well-developed, safe neighborhood, avg. 10,000-14,000 EGP/sqm
- Zamalek: Luxury island location, embassies nearby, avg. 18,000-25,000 EGP/sqm
- Downtown Cairo: Historic center, business hub, avg. 8,000-12,000 EGP/sqm

GIZA AREAS:
- Sheikh Zayed: Gated communities, upscale, avg. 14,000-19,000 EGP/sqm
- 6th of October City: Development zone, growing market, avg. 8,000-12,000 EGP/sqm
- Haram: Transitional area, growing demand, avg. 10,000-14,000 EGP/sqm

ALEXANDRIA ZONES:
- Al Montaza: Coastal premium, tourist area, avg. 12,000-16,000 EGP/sqm
- Mandara: Calm coastal, moderate prices, avg. 9,000-13,000 EGP/sqm
- San Stefano: Modern coastal, upscale, avg. 13,000-18,000 EGP/sqm

KEY RESPONSIBILITIES:
1. Present featured properties matching buyer requirements
2. Provide detailed location analysis and neighborhood insights
3. Guide buyers on price comparisons and market trends
4. Explain investment potential and rental yields
5. Help identify genuine listings and avoid scams
6. Offer market insights for Egyptian real estate

PRIMARY RESOURCE - Dubizzle Egypt:
- Website: https://www.dubizzle.com.eg/
- Dubizzle is Egypt's leading online classifieds platform for real estate
- Browse verified listings, compare prices, and connect with property sellers
- Features: Property search filters, price comparison tools, seller ratings, verified profiles
- More options: Commercial, villas, studios beyond these featured apartments

EXPERTISE AREAS:
- Residential apartments, villas, townhouses, studios
- Commercial properties (offices, shops, restaurants)
- Investment portfolio building
- Property valuation and market analysis
- Rental yield projections
- Area development trends
- Legal considerations and documentation

PRICING INSIGHTS:
- Budget Properties: 1,200,000 - 1,800,000 EGP (studios, smaller flats)
- Mid-Range: 2,000,000 - 3,500,000 EGP (2-3 bedroom apartments)
- Premium: 3,500,000 - 6,000,000 EGP (luxury apartments, villas)
- Luxury: 6,000,000+ EGP (exclusive properties, premium locations)

INVESTMENT GUIDE:
- Average Rental Yield: 6-12% annually depending on location
- Capital Appreciation: 3-8% yearly in growing areas
- Best Investment Areas: New Cairo, Sheikh Zayed, growing Alexandria
- ROI Timeline: 5-10 years for good appreciation
- Rental Market Demand: High in metro-accessible areas

When assisting buyers:
1. Understand their budget and location preferences
2. Recommend featured properties or suggest alternatives
3. Provide detailed location and market analysis
4. Explain investment potential and rental possibilities
5. Guide them to Dubizzle Egypt for full property database
6. Offer tips on verification and legal processes
7. Support throughout negotiation and decision-making

Remember: Your goal is to empower buyers with knowledge and real property options to make informed decisions and find genuine, valuable property offers in the Egyptian market.`
  );
  const [editingPrompt, setEditingPrompt] = useState(false);
  const [conversationId, setConversationId] = useState(() => 'conv_' + Math.random().toString(36).substr(2, 9));
  const [chatHistory, setChatHistory] = useState([]);
  const messagesEndRef = useRef(null);
  const apiUrl = 'https://sls-broker-api.idafh.com';
  
  useEffect(() => {
    loadChatHistory();
  }, []);

  useEffect(() => {
    saveChatToHistory();
  }, [messages, conversationId]);

  useEffect(() => {
    localStorage.setItem('chatHistory', JSON.stringify(chatHistory));
  }, [chatHistory]);

  const translations = {
    en: {
      title: 'Real Estate Assistant',
      subtitle: 'Find Your Perfect Property in Saudi Arabia',
      placeholder: 'Ask about properties, investments, or market trends...',
      send: 'Send',
      admin: 'Settings',
      language: 'العربية',
      apiKey: 'API Key',
      addKey: 'Add API Key',
      saveKey: 'Save Key',
      systemPrompt: 'System Prompt',
      save: 'Save',
      reset: 'Reset Chat',
      cancel: 'Cancel',
      dubizzle: 'Browse Dubizzle',
      history: 'History',
      noHistory: 'No conversations yet',
      newChat: 'New Chat',
      loadChat: 'Load',
      deleteChat: 'Delete',
      today: 'Today',
      yesterday: 'Yesterday',
      welcome: 'Welcome to Real Estate Assistant',
      description: 'Explore premium properties across Cairo, Giza, and Alexandria',
      suggestions: 'Try: "Show luxury apartments" or "What are rental yields?"',
    },
    ar: {
      title: 'مستشار العقارات',
      subtitle: 'اعثر على عقارك المثالي في مصر',
      placeholder: 'اسأل عن العقارات والاستثمارات واتجاهات السوق...',
      send: 'إرسال',
      admin: 'الإعدادات',
      language: 'English',
      apiKey: 'مفتاح API',
      addKey: 'إضافة مفتاح',
      saveKey: 'حفظ المفتاح',
      systemPrompt: 'التعليمات',
      save: 'حفظ',
      reset: 'إعادة تعيين',
      cancel: 'إلغاء',
      dubizzle: 'تصفح دوبيزل',
      history: 'السجل',
      noHistory: 'لا توجد محادثات',
      newChat: 'محادثة جديدة',
      loadChat: 'تحميل',
      deleteChat: 'حذف',
      today: 'اليوم',
      yesterday: 'أمس',
      welcome: 'مرحبا بك في مستشار العقارات',
      description: 'استكشف العقارات المتميزة في القاهرة والجيزة والإسكندرية',
      suggestions: 'جرب: "اظهر لي شقق فاخرة" أو "ما هي عوائد الايجار؟"',
    }
  };

  const t = translations[language];

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const saveChatToHistory = () => {
    if (messages.length > 0) {
      setChatHistory(prevHistory => {
        const existingIndex = prevHistory.findIndex(chat => chat.id === conversationId);
        const chatPreview = messages[0]?.content.substring(0, 50) || 'Chat';
        const newChat = {
          id: conversationId,
          title: chatPreview,
          timestamp: new Date(),
          messages: messages
        };

        if (existingIndex > -1) {
          const updated = [...prevHistory];
          updated[existingIndex] = newChat;
          return updated;
        }
        return [newChat, ...prevHistory];
      });
    }
  };

  const loadChatHistory = () => {
    const saved = localStorage.getItem('chatHistory');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setChatHistory(parsed);
      } catch (e) {
        console.error('Failed to load chat history:', e);
      }
    }
  };

  const loadChat = (chatId) => {
    const chat = chatHistory.find(c => c.id === chatId);
    if (chat) {
      setConversationId(chatId);
      setMessages(chat.messages);
      setShowHistory(false);
    }
  };

  const deleteChat = (chatId) => {
    setChatHistory(prevHistory => prevHistory.filter(c => c.id !== chatId));
  };

  const startNewChat = () => {
    const newId = 'conv_' + Math.random().toString(36).substr(2, 9);
    setConversationId(newId);
    setMessages([]);
    setShowHistory(false);
  };

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { role: 'user', content: input };
    const userInput = input;
    setMessages(prev => [...prev, userMessage]);
    setInput('');
    setLoading(true);

    try {
      const url = `${apiUrl}/api/chat`;
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          conversation_id: conversationId,
          message: userInput,
          system_prompt: systemPrompt
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}. Message: ${errorText}`);
      }
      
      const data = await response.json();
      const botMessage = { role: 'assistant', content: data.response };
      setMessages(prev => [...prev, botMessage]);
    } catch (error) {
      console.error('Error:', error);
      const errorMsg = { role: 'assistant', content: `Error: ${error.message}` };
      setMessages(prev => [...prev, errorMsg]);
    } finally {
      setLoading(false);
    }
  };

  const handleSetApiKey = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/set-api-key`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ api_key: apiKey })
      });

      if (response.ok) {
        setShowApiForm(false);
        setApiKey('');
        alert('API Key set successfully');
      }
    } catch (error) {
      console.error('Error setting API key:', error);
      alert('Error setting API key');
    }
  };

  const handleSavePrompt = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/prompts/${conversationId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: systemPrompt })
      });

      if (response.ok) {
        setEditingPrompt(false);
        alert('Prompt saved');
      }
    } catch (error) {
      console.error('Error saving prompt:', error);
    }
  };

  const handleReset = async () => {
    try {
      await fetch(`${apiUrl}/api/conversations/${conversationId}/reset`, { method: 'POST' });
      startNewChat();
    } catch (error) {
      console.error('Error resetting:', error);
    }
  };

  const formatDate = (date) => {
    const now = new Date();
    const chatDate = new Date(date);
    const diffTime = Math.abs(now - chatDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return t.today;
    if (diffDays === 1) return t.yesterday;
    return chatDate.toLocaleDateString();
  };

  return (
    <div className={`flex h-screen bg-white ${language === 'ar' ? 'rtl' : 'ltr'}`}>
      {/* Chat Interface */}
      <div className="flex-1 flex flex-col bg-gradient-to-b from-gray-50 to-white">
        {/* Header */}
        <div className="bg-white border-b border-gray-200 px-8 py-5 shadow-sm">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">{t.title}</h1>
              <p className="text-gray-500 text-sm mt-1">{t.subtitle}</p>
            </div>
            <div className="flex gap-2">
              <button 
                onClick={() => setShowHistory(!showHistory)} 
                className="px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 rounded-lg flex items-center gap-2 font-medium transition-colors"
              >
                <History size={18} /> {t.history}
              </button>
              <button 
                onClick={() => setLanguage(language === 'en' ? 'ar' : 'en')} 
                className="px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 rounded-lg flex items-center gap-2 font-medium transition-colors"
              >
                <Globe size={18} /> {t.language}
              </button>
              <button 
                onClick={() => setShowAdmin(!showAdmin)} 
                className="px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 rounded-lg flex items-center gap-2 font-medium transition-colors"
              >
                <Settings size={18} />
              </button>
            </div>
          </div>
        </div>

        {/* Messages Container */}
        <div className="flex-1 overflow-y-auto p-6 space-y-4">
          {messages.length === 0 ? (
            <div className="flex items-center justify-center h-full">
              <div className="text-center max-w-md">
                <div className="mb-6">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-gray-100 rounded-2xl mb-4">
                    <MessageSquare className="w-10 h-10 text-gray-400" />
                  </div>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">{t.welcome}</h2>
                <p className="text-gray-600 mb-4">{t.description}</p>
                <p className="text-sm text-gray-500 mb-6">{t.suggestions}</p>
                {chatHistory.length > 0 && (
                  <button 
                    onClick={() => setShowHistory(true)} 
                    className="inline-flex items-center gap-2 px-6 py-2 bg-gray-900 hover:bg-gray-800 text-white rounded-lg font-medium transition-colors"
                  >
                    <History size={18} /> {t.history}
                  </button>
                )}
              </div>
            </div>
          ) : (
            <>
              {messages.map((msg, idx) => (
                <div key={idx} className={`flex ${msg.role === 'user' ? (language === 'ar' ? 'justify-start' : 'justify-end') : (language === 'ar' ? 'justify-end' : 'justify-start')}`}>
                  <div className={`max-w-lg px-4 py-3 rounded-2xl ${msg.role === 'user' ? 'bg-gray-900 text-white rounded-br-none' : 'bg-gray-100 text-gray-900 rounded-bl-none'}`}>
                    <p className="text-sm leading-relaxed">{msg.content}</p>
                  </div>
                </div>
              ))}
              {loading && (
                <div className="flex justify-start">
                  <div className="bg-gray-100 rounded-2xl rounded-bl-none px-4 py-3">
                    <div className="flex gap-2">
                      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
                      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
                      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{animationDelay: '0.4s'}}></div>
                    </div>
                  </div>
                </div>
              )}
              <div ref={messagesEndRef} />
            </>
          )}
        </div>

        {/* Input Area */}
        <div className="bg-white border-t border-gray-200 px-8 py-4">
          <div className="flex gap-3">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
              placeholder={t.placeholder}
              className="flex-1 bg-gray-100 text-gray-900 rounded-full px-6 py-3 focus:outline-none focus:ring-2 focus:ring-gray-400 transition-all placeholder-gray-500 border-0"
            />
            <button 
              onClick={sendMessage} 
              disabled={loading} 
              className="bg-gray-900 hover:bg-gray-800 disabled:bg-gray-400 text-white rounded-full p-3 flex items-center justify-center transition-colors"
            >
              <Send size={20} />
            </button>
          </div>
        </div>
      </div>

      {/* History Panel */}
      {showHistory && (
        <div className="w-80 bg-white border-l border-gray-200 flex flex-col">
          {/* Header */}
          <div className="flex justify-between items-center p-6 border-b border-gray-200">
            <h3 className="text-lg font-bold text-gray-900">{t.history}</h3>
            <button 
              onClick={() => setShowHistory(false)} 
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <X size={20} />
            </button>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto p-4 space-y-3">
            <button 
              onClick={startNewChat} 
              className="w-full bg-gray-900 hover:bg-gray-800 text-white rounded-lg px-4 py-3 flex items-center gap-2 justify-center font-medium transition-colors"
            >
              <Plus size={18} /> {t.newChat}
            </button>

            {chatHistory.length === 0 ? (
              <p className="text-gray-500 text-center py-8">{t.noHistory}</p>
            ) : (
              chatHistory.map(chat => (
                <div key={chat.id} className="bg-gray-50 rounded-lg p-3 border border-gray-200 hover:border-gray-300 transition-colors">
                  <div className="flex justify-between items-start gap-2 mb-2">
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-900 truncate">{chat.title}</p>
                      <p className="text-xs text-gray-500 mt-1">{formatDate(chat.timestamp)}</p>
                    </div>
                    <button 
                      onClick={() => deleteChat(chat.id)}
                      className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                  <button 
                    onClick={() => loadChat(chat.id)}
                    className="w-full bg-gray-900 hover:bg-gray-800 text-white rounded-lg px-3 py-2 text-xs font-medium transition-colors"
                  >
                    {t.loadChat}
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      )}

      {/* Admin Panel */}
      {showAdmin && (
        <div className="w-96 bg-white border-l border-gray-200 flex flex-col">
          {/* Header */}
          <div className="flex justify-between items-center p-6 border-b border-gray-200">
            <h3 className="text-lg font-bold text-gray-900">{t.admin}</h3>
            <button 
              onClick={() => setShowAdmin(false)} 
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <X size={20} />
            </button>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto p-6 space-y-6">
            {/* API Key Section */}
            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-3">{t.apiKey}</label>
              {!showApiForm ? (
                <button 
                  onClick={() => setShowApiForm(true)} 
                  className="w-full bg-gray-900 hover:bg-gray-800 text-white rounded-lg px-4 py-3 flex items-center gap-2 justify-center font-medium transition-colors"
                >
                  <Plus size={18} /> {t.addKey}
                </button>
              ) : (
                <div className="space-y-3">
                  <input
                    type="password"
                    value={apiKey}
                    onChange={(e) => setApiKey(e.target.value)}
                    placeholder="sk-..."
                    className="w-full bg-gray-100 text-gray-900 border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-gray-400 transition-colors"
                  />
                  <div className="flex gap-2">
                    <button 
                      onClick={handleSetApiKey} 
                      className="flex-1 bg-gray-900 hover:bg-gray-800 text-white rounded-lg px-3 py-2 text-sm font-medium flex items-center gap-1 justify-center transition-colors"
                    >
                      <Save size={16} /> {t.saveKey}
                    </button>
                    <button 
                      onClick={() => setShowApiForm(false)} 
                      className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-900 rounded-lg px-3 py-2 text-sm font-medium transition-colors"
                    >
                      {t.cancel}
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Prompt Section */}
            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-3">{t.systemPrompt}</label>
              {!editingPrompt ? (
                <button 
                  onClick={() => setEditingPrompt(true)} 
                  className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-300 rounded-lg p-3 text-sm text-center transition-colors flex items-center justify-center gap-2"
                >
                  <Edit2 size={16} /> Edit Prompt
                </button>
              ) : (
                <div className="space-y-3">
                  <textarea
                    value={systemPrompt}
                    onChange={(e) => setSystemPrompt(e.target.value)}
                    className="w-full h-32 bg-gray-100 text-gray-900 border border-gray-300 rounded-lg px-4 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-gray-400 transition-colors resize-none"
                  />
                  <button 
                    onClick={handleSavePrompt} 
                    className="w-full bg-gray-900 hover:bg-gray-800 text-white rounded-lg px-3 py-2 text-sm font-medium flex items-center gap-2 justify-center transition-colors"
                  >
                    <Save size={16} /> {t.save}
                  </button>
                </div>
              )}
            </div>

            {/* Reset Button */}
            <button 
              onClick={handleReset} 
              className="w-full bg-gray-900 hover:bg-gray-800 text-white rounded-lg px-4 py-3 flex items-center gap-2 justify-center font-medium transition-colors"
            >
              <Trash2 size={18} /> {t.reset}
            </button>

            {/* Dubizzle Link */}
            <a 
              href="https://www.dubizzle.com.eg/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-full bg-gray-100 hover:bg-gray-200 text-gray-900 border border-gray-300 rounded-lg px-4 py-3 flex items-center gap-2 justify-center font-medium transition-colors"
            >
              🏠 Dubizzle Egypt <ArrowRight size={16} />
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatBot;
